// <s-theme-toggle> flips the storefront between the dark (default) and light palettes.
// The choice is stored per browser; an inline head script applies it before first paint.
const KEY = 'rnu-theme';

class SThemeToggle extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    this.button?.addEventListener('click', this.#toggle);
    this.#sync();
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.#toggle);
  }

  #toggle = () => {
    const next = document.documentElement.dataset.theme === 'light' ? 'dark' : 'light';
    document.documentElement.dataset.theme = next;
    try {
      localStorage.setItem(KEY, next);
    } catch (error) {
      // Storage blocked: the switch still works for this page view.
    }
    this.#sync();
  };

  #sync() {
    const light = document.documentElement.dataset.theme === 'light';
    this.button?.setAttribute('aria-pressed', String(light));
    this.button?.setAttribute('aria-label', light ? this.dataset.labelDark : this.dataset.labelLight);
  }
}

if (!customElements.get('s-theme-toggle')) customElements.define('s-theme-toggle', SThemeToggle);
